import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { HelperService } from 'src/app/services/shared/helper/helper.service';
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  public faUser = faUser;
  public faSignOutAlt = faSignOutAlt;
  public faCreditCard = faCreditCard;
  public name: string = "";
  public email: string = "";

  constructor(private _authService: AuthenticationService, private _helper: HelperService, private _router: Router) { }

  ngOnInit() {
    var user = this._helper.user.get();
    if(user && user['name']){
      this.name = user['name'];
    }
    if(user && user['email']){
      this.email = user['email'];
    }
  }

  goToSubscription() {
    this._router.navigateByUrl('app/subscriptions');
  }

  onLogout(){
    this._authService.logout();
  }

}
